// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__fHWHo","spin":"Loading_spin__27TzB","container":"Loading_container__o1Lrm","overlay":"Loading_overlay__2qJgM","text":"Loading_text__rnQTQ"};